import { Component, OnInit } from '@angular/core';
import { USER_ROLES } from '../../../enums';
import { LoadingAndErrors } from '../../../classes';
import { UserDataApi, PartnerApi } from '../../../../assets/js/lb-sdk';
import { finalize } from 'rxjs/operators';
import { BsModalRef } from 'ngx-bootstrap';
import { HasRolePipe } from '../../../pipes/has-role.pipe';

@Component({
  selector: 'app-agent-profile',
  templateUrl: './agent-profile.component.html',
  styleUrls: ['./agent-profile.component.css']
})
export class AgentProfileComponent extends LoadingAndErrors implements OnInit {
  merchantDetails;
  USER_ROLES: typeof USER_ROLES = USER_ROLES;
  agent;
  data;

  constructor(
    private hasRole: HasRolePipe,
    public modal: BsModalRef,
    private agentDataApi: UserDataApi,
    private partnerApi: PartnerApi
  ) {
    super();
  }

  ngOnInit() {
    this.loading.merchant = true;
    this.clearErrors();
    this.partnerApi
      .findById((this.data || {}).merchantId)
      .pipe(finalize(() => {
        this.loading.merchant = false;
      }))
      .subscribe(
        details => {
          this.merchantDetails = details;
        },
        error => {
          this.errors.merchant = error.message || 'Unable to get Merchant Details';
        }
      );
  }

  dismiss() {
    this.modal.hide();
  }

  close() {
    this.modal.hide();
  }
}
